import { ActiveInvocationsStatus } from "@/shared/components/actions/ActiveInvocationsStatus";
import { useActiveSessionInvocations } from "@/shared/domain/actions/hooks";

interface SessionActionStatusProps {
  sessionId: string;
}

/** After the session's Actions tab label: whether any invocation on the session is pending or running. */
export function SessionActionStatus({ sessionId }: SessionActionStatusProps) {
  const invocationsQuery = useActiveSessionInvocations(sessionId);
  return <ActiveInvocationsStatus invocations={invocationsQuery.data?.items} />;
}
